import React from 'react';
import '../../FormBuilder.css';

const TwoDSingleScanElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === '2dSingleScan' && (
        <label className='titleTextLbl'>
            {component.fieldName || "2D Signle Scan"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>  
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default TwoDSingleScanElement;
